define('v3/Common/Services/Backend/abilityGrowthBackend',[
	'jquery',
	'BackendBase'
],
function ($, BackendBase) {
	function Constructor () {
		BackendBase.call(this);
	}

	Constructor.prototype = $.extend({}, BackendBase.prototype);
	$.extend(Constructor.prototype,
		{
			getUserAbilityGrowthBySubjectGroup: function (pupilId, subjectGroupId, period, usePupilAverageGrowth) {
				if (usePupilAverageGrowth) {
					var url = Settings.metricsApi;
					return this._getJsonApiWithJwtAuthorization(url + '/Growth/' + subjectGroupId + '/Pupils/' + pupilId,
						{ period: period }, { showError: false });
				} else {
					return this._getJsonApi('SubjectGroupAbilityGrowth/' + subjectGroupId + '/Pupils/' + pupilId,
						{
							period: period
						});
				}
			}
		});

	return new Constructor();
});
